/**
 * Libellés de l'interface VtM, séparés des traductions Aria.
 */
import i18next from 'i18next';

const LABELS = {
  attributes: {fr: 'Attributs', en: 'Attributes'},
  skills: {fr: 'Compétences', en: 'Skills'},
  disciplines: {fr: 'Disciplines', en: 'Disciplines'},
  hunger: {fr: 'Soif', en: 'Hunger'},
  health: {fr: 'Santé', en: 'Health'},
  willpower: {fr: 'Volonté', en: 'Willpower'},
  humanity: {fr: 'Humanité', en: 'Humanity'},
  stains: {fr: 'souillure(s)', en: 'stain(s)'},
  superficial: {fr: 'superficiel', en: 'superficial'},
  aggravated: {fr: 'aggravé', en: 'aggravated'},
  impaired: {fr: 'Diminué', en: 'Impaired'},
  clan: {fr: 'Clan', en: 'Clan'},
  generation: {fr: 'Génération', en: 'Generation'},
  generationValue: {fr: '{{value}}e', en: '{{value}}th'},
  predator: {fr: 'Prédateur', en: 'Predator'},
  bloodPotency: {fr: 'Puiss. du sang', en: 'Blood potency'},
  sire: {fr: 'Sire', en: 'Sire'},
  ambition: {fr: 'Ambition', en: 'Ambition'},
  desire: {fr: 'Désir', en: 'Desire'},
  bane: {fr: 'Fléau', en: 'Bane'},
  compulsion: {fr: 'Compulsion', en: 'Compulsion'},
  advantages: {fr: 'Avantages', en: 'Advantages'},
  flaws: {fr: 'Handicaps', en: 'Flaws'},
  convictions: {fr: 'Convictions', en: 'Convictions'},
  touchstone: {fr: 'Pierre de touche', en: 'Touchstone'},
  experience: {fr: 'Expérience', en: 'Experience'},
  xpAvailable: {fr: '{{value}} XP disponibles', en: '{{value}} XP available'},
  rouseFree: {fr: 'gratuit', en: 'free'},
  rouseCost: {fr: "{{value}} test(s) d'exaltation", en: '{{value}} Rouse check(s)'},
  status_draft: {fr: 'Brouillon', en: 'Draft'},
  status_pending: {fr: 'À valider par le MJ', en: 'Awaiting DM approval'},
  status_approved: {fr: 'Validé', en: 'Approved'},
  loading: {fr: 'Chargement…', en: 'Loading…'},
  notFound: {fr: 'Personnage introuvable.', en: 'Character not found.'},
  forbidden: {fr: "Cette fiche n'est visible que par son joueur et le MJ.", en: 'Only the player and the DM can see this sheet.'},
  noneYet: {fr: 'Aucun pour le moment', en: 'None yet'},
  // Assistant de création
  newCharacter: {fr: 'Nouveau personnage', en: 'New character'},
  creationTitle: {fr: 'Création de personnage', en: 'Character creation'},
  step_concept: {fr: 'Concept', en: 'Concept'},
  step_clan: {fr: 'Clan', en: 'Clan'},
  step_predator: {fr: 'Prédateur', en: 'Predator'},
  step_attributes: {fr: 'Attributs', en: 'Attributes'},
  step_skills: {fr: 'Compétences', en: 'Skills'},
  step_disciplines: {fr: 'Disciplines', en: 'Disciplines'},
  step_advantages: {fr: 'Avantages', en: 'Advantages'},
  step_convictions: {fr: 'Convictions', en: 'Convictions'},
  step_summary: {fr: 'Finalisation', en: 'Summary'},
  stepHelp_concept: {fr: 'Qui était-il avant l\'Étreinte, et que veut-il maintenant ? Une phrase suffit pour le concept.', en: 'Who were they before the Embrace, and what do they want now? One sentence is enough.'},
  stepHelp_clan: {fr: 'Le clan donne trois disciplines de prédilection, un fléau et une compulsion.', en: 'Your clan grants three disciplines, a bane and a compulsion.'},
  stepHelp_predator: {fr: 'Comment se nourrit-il ? Le type de prédateur donne une spécialité, un point de discipline et des avantages ou handicaps.', en: 'How do they feed? The predator type grants a specialty, a discipline dot and some merits or flaws.'},
  stepHelp_attributes: {fr: 'Répartissez : un attribut à 4, trois à 3, quatre à 2 et un à 1.', en: 'Distribute: one attribute at 4, three at 3, four at 2 and one at 1.'},
  stepHelp_skills: {fr: 'Choisissez un profil, puis répartissez les points. Érudition, Artisanat, Représentation et Science exigent une spécialité ; ajoutez-en une libre.', en: 'Pick a profile, then distribute dots. Academics, Craft, Performance and Science need a specialty; add one free specialty.'},
  stepHelp_disciplines: {fr: '2 points dans une discipline de clan, 1 dans une autre, plus le point du prédateur. Un pouvoir par point, par paliers : au moins un de niveau 1, le 2e de niveau 2 max, le 3e de niveau 3 max.', en: '2 dots in one clan discipline, 1 in another, plus the predator dot. One power per dot, by tiers: at least one level 1, the 2nd at most level 2, the 3rd at most level 3.'},
  stepHelp_advantages: {fr: '7 points d\'avantages et 2 points de handicaps. Ceux du prédateur sont offerts en plus.', en: '7 points of advantages and 2 points of flaws. Predator ones come on top.'},
  stepHelp_convictions: {fr: 'Une à trois convictions, chacune liée à une pierre de touche : un mortel qui l\'incarne.', en: 'One to three convictions, each tied to a touchstone: a mortal who embodies it.'},
  stepHelp_summary: {fr: 'Vérifiez la fiche puis envoyez-la au MJ.', en: 'Check the sheet, then send it to the DM.'},
  previous: {fr: 'Précédent', en: 'Previous'},
  next: {fr: 'Suivant', en: 'Next'},
  saved: {fr: 'Brouillon enregistré', en: 'Draft saved'},
  saving: {fr: 'Enregistrement…', en: 'Saving…'},
  submit: {fr: 'Envoyer au MJ', en: 'Send to the DM'},
  submitted: {fr: 'Fiche envoyée au MJ.', en: 'Sheet sent to the DM.'},
  incompleteSteps: {fr: 'Étapes à compléter : {{steps}}', en: 'Steps to complete: {{steps}}'},
  name: {fr: 'Nom', en: 'Name'},
  concept: {fr: 'Concept', en: 'Concept'},
  conceptPlaceholder: {fr: 'Galeriste nocturne, flic désabusé…', en: 'Night gallerist, jaded cop…'},
  ambitionPlaceholder: {fr: 'Un but à long terme', en: 'A long-term goal'},
  desirePlaceholder: {fr: 'Une envie pour la séance', en: 'A short-term want'},
  disciplinesShort: {fr: 'Disciplines', en: 'Disciplines'},
  disciplineShort: {fr: 'Discipline', en: 'Discipline'},
  or: {fr: 'ou', en: 'or'},
  anyDisciplines: {fr: 'Au choix', en: 'Any'},
  selected: {fr: 'Choisi', en: 'Selected'},
  huntPool: {fr: 'Chasse', en: 'Hunting'},
  predatorSpecialty: {fr: 'Spécialité offerte', en: 'Granted specialty'},
  predatorSpecialtyName: {fr: 'Nom de la spécialité', en: 'Specialty name'},
  predatorDiscipline: {fr: 'Point de discipline offert', en: 'Granted discipline dot'},
  predatorGrants: {fr: 'Offert', en: 'Granted'},
  predatorChoice: {fr: 'À ajouter vous-même à l\'étape Avantages', en: 'Add yourself at the Advantages step'},
  humanityChange: {fr: 'Humanité {{value}}', en: 'Humanity {{value}}'},
  bloodPotencyChange: {fr: 'Puissance du Sang {{value}}', en: 'Blood potency {{value}}'},
  notForClan: {fr: 'Indisponible pour ce clan', en: 'Not available for this clan'},
  chooseClanFirst: {fr: 'Choisissez d\'abord un clan.', en: 'Choose a clan first.'},
  distribution: {fr: 'Répartition', en: 'Distribution'},
  profile: {fr: 'Profil', en: 'Profile'},
  requiredSpecialties: {fr: 'Spécialités obligatoires', en: 'Required specialties'},
  freeSpecialty: {fr: 'Spécialité libre', en: 'Free specialty'},
  specialtyName: {fr: 'Nom', en: 'Name'},
  chooseSkill: {fr: '— compétence —', en: '— skill —'},
  creationDots: {fr: 'Points de création', en: 'Creation dots'},
  predatorDot: {fr: '+1 prédateur', en: '+1 predator'},
  powersToChoose: {fr: 'Pouvoirs ({{count}}/{{max}})', en: 'Powers ({{count}}/{{max}})'},
  amalgamRequires: {fr: 'amalgame : {{discipline}} {{level}}', en: 'amalgam: {{discipline}} {{level}}'},
  thinBloodDisciplines: {fr: 'Un Sang-Clair n\'a pas de discipline de clan : seul le point du prédateur compte.', en: 'Thin-bloods have no clan disciplines: only the predator dot counts.'},
  budget: {fr: '{{spent}} / {{total}} points', en: '{{spent}} / {{total}} points'},
  fromPredator: {fr: 'Offerts par le prédateur', en: 'Granted by the predator'},
  add: {fr: 'Ajouter', en: 'Add'},
  remove: {fr: 'Retirer', en: 'Remove'},
  advantageName: {fr: 'Nom', en: 'Name'},
  advantageDescription: {fr: 'Description', en: 'Description'},
  advantageLevel: {fr: 'Valeur', en: 'Value'},
  addConviction: {fr: 'Ajouter une conviction', en: 'Add a conviction'},
  conviction: {fr: 'Conviction', en: 'Conviction'},
  convictionPlaceholder: {fr: 'Ne jamais faire de mal à un enfant', en: 'Never harm a child'},
  touchstonePlaceholder: {fr: 'Un mortel qui l\'incarne', en: 'A mortal who embodies it'},
  startingProfile: {fr: 'Néonate · {{generation}}e génération · Puissance du Sang {{bloodPotency}} · 0 XP', en: 'Neonate · {{generation}}th generation · Blood potency {{bloodPotency}} · 0 XP'},
  draftOf: {fr: 'Brouillon', en: 'Draft'},
  err_missingName: {fr: 'Donnez un nom au personnage.', en: 'Give the character a name.'},
  err_missingConcept: {fr: 'Indiquez un concept.', en: 'Enter a concept.'},
  err_missingClan: {fr: 'Choisissez un clan.', en: 'Choose a clan.'},
  err_missingPredator: {fr: 'Choisissez un type de prédateur.', en: 'Choose a predator type.'},
  err_missingPredatorSpecialty: {fr: 'Nommez la spécialité offerte par le prédateur.', en: 'Name the predator specialty.'},
  err_missingPredatorDiscipline: {fr: 'Choisissez la discipline offerte par le prédateur.', en: 'Choose the predator discipline.'},
  err_noDistribution: {fr: 'Choisissez un profil de compétences.', en: 'Choose a skill profile.'},
  err_distribution: {fr: 'Traits à {{value}} : {{have}} / {{want}}', en: 'Traits at {{value}}: {{have}} / {{want}}'},
  err_missingRequired: {fr: 'Spécialité obligatoire manquante : {{skill}}', en: 'Missing required specialty: {{skill}}'},
  err_skillWithoutDots: {fr: '{{skill}} doit avoir au moins 1 point pour sa spécialité.', en: '{{skill}} needs at least 1 dot for its specialty.'},
  err_emptyName: {fr: 'Une spécialité ou un avantage n\'a pas de nom.', en: 'A specialty or advantage has no name.'},
  err_freeCount: {fr: 'Choisissez une spécialité libre ({{have}} / {{want}}).', en: 'Choose one free specialty ({{have}} / {{want}}).'},
  err_missingPredator_skills: {fr: 'Le prédateur doit offrir une spécialité.', en: 'The predator must grant a specialty.'},
  err_dots: {fr: 'Répartissez 2 points dans une discipline et 1 dans une autre.', en: 'Put 2 dots in one discipline and 1 in another.'},
  err_notClanDiscipline: {fr: '{{discipline}} n\'est pas une discipline de votre clan.', en: '{{discipline}} is not one of your clan disciplines.'},
  err_missingPredatorDot: {fr: 'Le point du prédateur est manquant.', en: 'The predator dot is missing.'},
  err_thinBloodNoClanDots: {fr: 'Un Sang-Clair ne peut pas avoir de points de clan.', en: 'Thin-bloods cannot have clan dots.'},
  err_count: {fr: '{{discipline}} : choisissez {{want}} pouvoir(s) ({{have}} choisi(s)).', en: '{{discipline}}: choose {{want}} power(s) ({{have}} chosen).'},
  err_tiers: {fr: '{{discipline}} : les pouvoirs se prennent par paliers (au moins un de niveau 1, le 2e ≤ 2, le 3e ≤ 3…).', en: '{{discipline}}: powers follow tiers (at least one level 1, the 2nd ≤ 2, the 3rd ≤ 3…).'},
  err_levelTooHigh: {fr: 'Un pouvoir est de niveau trop élevé.', en: 'A power is too high level.'},
  err_amalgam: {fr: 'Un pouvoir d\'amalgame n\'a pas sa discipline secondaire.', en: 'An amalgam power lacks its secondary discipline.'},
  err_unknownPower: {fr: 'Pouvoir inconnu.', en: 'Unknown power.'},
  err_level: {fr: 'Chaque avantage vaut entre 1 et 5.', en: 'Each advantage is worth 1 to 5.'},
  err_kind: {fr: 'Type d\'avantage invalide.', en: 'Invalid advantage type.'},
  err_advantageBudget: {fr: 'Avantages : {{have}} / {{want}} points.', en: 'Advantages: {{have}} / {{want}} points.'},
  err_flawBudget: {fr: 'Handicaps : {{have}} / {{want}} points.', en: 'Flaws: {{have}} / {{want}} points.'},
  err_convictionCount: {fr: 'Ajoutez 1 à 3 convictions.', en: 'Add 1 to 3 convictions.'},
  err_missingTouchstone: {fr: 'Chaque conviction a besoin d\'une pierre de touche.', en: 'Each conviction needs a touchstone.'},
  err_noClan: {fr: 'Choisissez un clan.', en: 'Choose a clan.'},
  // Connexion
  loginEyebrow: {fr: 'Vampire : la Mascarade · V5', en: 'Vampire: The Masquerade · V5'},
  loginSubtitle: {fr: 'Les nuits vous attendent', en: 'The nights are waiting'},
  loginText: {fr: 'Fiches de personnage, jets de dés et chat de campagne, partagés en direct avec votre coterie.', en: 'Character sheets, dice rolls and campaign chat, shared live with your coterie.'},
  loginGoogle: {fr: 'Se connecter avec Google', en: 'Sign in with Google'},
  loginFootnote: {fr: 'Outil de fan non officiel pour Vampire : la Mascarade.', en: 'Unofficial fan tool for Vampire: The Masquerade.'},
  dmCard: {fr: 'Vue du MJ', en: 'DM view'},
  // Progression et édition
  xpPurchase: {fr: 'Achat XP', en: 'XP purchase'},
  spendXp: {fr: "Dépenser de l'XP", en: 'Spend XP'},
  editProfile: {fr: 'Modifier', en: 'Edit'},
  editProfileTitle: {fr: 'Modifier le personnage', en: 'Edit character'},
  powerNotes: {fr: 'Notes sur les pouvoirs', en: 'Power notes'},
  powerNotesHint: {fr: 'Ce que fait le pouvoir, dans vos mots. La note apparaît au survol sur la fiche.', en: 'What the power does, in your own words. The note shows on hover on the sheet.'},
  powerNotePlaceholder: {fr: 'Effet, durée, cible…', en: 'Effect, duration, target…'},
  purchaseType: {fr: 'Que voulez-vous acheter ?', en: 'What do you want to buy?'},
  purchase_attribute: {fr: 'Attribut', en: 'Attribute'},
  purchase_skill: {fr: 'Compétence', en: 'Skill'},
  purchase_specialty: {fr: 'Spécialité', en: 'Specialty'},
  purchase_discipline: {fr: 'Discipline (nouveau point + pouvoir)', en: 'Discipline (new dot + power)'},
  purchase_newAdvantage: {fr: 'Nouvel avantage', en: 'New advantage'},
  purchase_advantageDot: {fr: "Point d'avantage existant", en: 'Dot on an existing advantage'},
  purchase_bloodPotency: {fr: 'Puissance du Sang', en: 'Blood potency'},
  chooseOption: {fr: '— choisir —', en: '— choose —'},
  power: {fr: 'Pouvoir', en: 'Power'},
  xpCost: {fr: 'Coût : {{cost}} XP', en: 'Cost: {{cost}} XP'},
  xpAvailableShort: {fr: '{{value}} XP disponibles', en: '{{value}} XP available'},
  buy: {fr: 'Acheter', en: 'Buy'},
  bought: {fr: 'Acheté : {{summary}}', en: 'Bought: {{summary}}'},
  clanDisciplineTag: {fr: 'clan', en: 'clan'},
  outOfClanTag: {fr: 'hors clan', en: 'out of clan'},
  newTag: {fr: 'nouvelle', en: 'new'},
  xpErr_max: {fr: 'Déjà au maximum.', en: 'Already at maximum.'},
  xpErr_notEnoughXp: {fr: "Pas assez d'XP ({{cost}} nécessaires).", en: 'Not enough XP ({{cost}} needed).'},
  xpErr_skillWithoutDots: {fr: 'La compétence doit avoir au moins 1 point.', en: 'The skill needs at least 1 dot.'},
  xpErr_emptyName: {fr: 'Indiquez un nom.', en: 'Enter a name.'},
  xpErr_duplicate: {fr: 'Cette spécialité existe déjà.', en: 'This specialty already exists.'},
  xpErr_invalidPower: {fr: 'Choisissez un pouvoir.', en: 'Choose a power.'},
  xpErr_level: {fr: 'Valeur entre 1 et 5.', en: 'Value between 1 and 5.'},
  xpErr_unknown: {fr: 'Faites votre choix.', en: 'Make a choice.'},
  portrait: {fr: 'Portrait', en: 'Portrait'},
  changePortrait: {fr: 'Changer le portrait', en: 'Change portrait'},
  portraitTooBig: {fr: 'Image trop lourde (5 Mo maximum).', en: 'Image too large (5 MB max).'},
  uploading: {fr: 'Envoi…', en: 'Uploading…'},
  save: {fr: 'Enregistrer', en: 'Save'},
  cancel: {fr: 'Annuler', en: 'Cancel'},
  // Vue MJ
  dmTitle: {fr: 'Vue du MJ', en: 'DM view'},
  backToDm: {fr: '← Vue MJ', en: '← DM view'},
  dmOnly: {fr: 'Cette page est réservée au MJ de la campagne.', en: 'This page is for the campaign DM only.'},
  coterie: {fr: 'La coterie', en: 'The coterie'},
  pendingApproval: {fr: 'Fiches à valider', en: 'Sheets to approve'},
  drafts: {fr: 'Brouillons en cours', en: 'Drafts in progress'},
  noCharacters: {fr: 'Aucun personnage dans la campagne pour le moment.', en: 'No characters in this campaign yet.'},
  approve: {fr: 'Valider', en: 'Approve'},
  backToDraft: {fr: 'Renvoyer en brouillon', en: 'Send back to draft'},
  openSheet: {fr: 'Ouvrir la fiche', en: 'Open sheet'},
  playerOf: {fr: 'Joueur', en: 'Player'},
  dmRoll: {fr: 'Jet du MJ', en: 'DM roll'},
  dmRollHint: {fr: 'Pour un PNJ ou une opposition : choisissez la réserve directement.', en: 'For an NPC or an opposition: set the pool directly.'},
  npcName: {fr: 'Qui lance ?', en: 'Who rolls?'},
  npcNamePlaceholder: {fr: 'Garde du Prince, Sheriff…', en: "Prince's guard, Sheriff…"},
  poolSize: {fr: 'Dés', en: 'Dice'},
  hungerDiceCount: {fr: 'Dont Soif', en: 'Hunger dice'},
  dm: {fr: 'MJ', en: 'DM'},
  campaignPanel: {fr: 'Campagne', en: 'Campaign'},
  campaignName: {fr: 'Nom de la campagne', en: 'Campaign name'},
  invitationCode: {fr: "Code d'invitation", en: 'Invitation code'},
  copy: {fr: 'Copier', en: 'Copy'},
  copied: {fr: 'Copié', en: 'Copied'},
  rename: {fr: 'Renommer', en: 'Rename'},
  archive: {fr: 'Archiver', en: 'Archive'},
  archiveCampaign: {fr: 'Archiver la campagne', en: 'Archive the campaign'},
  archiveCampaignConfirm: {fr: 'La campagne disparaîtra de la liste de tous les joueurs, avec ses personnages. Continuer ?', en: 'The campaign will disappear for every player, with its characters. Continue?'},
  archiveCharacter: {fr: 'Archiver le personnage', en: 'Archive the character'},
  archiveCharacterConfirm: {fr: '{{name}} disparaîtra de la campagne (mort, départ…). Continuer ?', en: '{{name}} will leave the campaign (death, departure…). Continue?'},
  cheatsheet: {fr: 'Aide-mémoire', en: 'Cheat sheet'},
  difficulties: {fr: 'Difficultés', en: 'Difficulties'},
  commonPools: {fr: 'Réserves courantes', en: 'Common pools'},
  npcBenchmarks: {fr: 'Repères de PNJ', en: 'NPC benchmarks'},
  npcType: {fr: 'Type', en: 'Type'},
  npcBest: {fr: 'Meilleure réserve', en: 'Best pool'},
  npcUsual: {fr: 'Réserve courante', en: 'Usual pool'},
  npcBenchmarksNote: {fr: 'Ordres de grandeur indicatifs, à ajuster selon la scène.', en: 'Rough guidelines, adjust to the scene.'},
  ruleReminders: {fr: 'Rappels', en: 'Reminders'},
  // Édition des jauges
  setHunger: {fr: 'Mettre la Soif à {{value}}', en: 'Set Hunger to {{value}}'},
  cycleBox: {fr: '{{track}}, case {{value}} : changer le dégât', en: '{{track}}, box {{value}}: change damage'},
  setHumanity: {fr: "Mettre l'Humanité à {{value}}", en: 'Set Humanity to {{value}}'},
  stainsLabel: {fr: 'Souillures', en: 'Stains'},
  addStain: {fr: 'Ajouter une souillure', en: 'Add a stain'},
  removeStain: {fr: 'Retirer une souillure', en: 'Remove a stain'},
  xpEarned: {fr: 'Gagnée', en: 'Earned'},
  xpEarnedPlus: {fr: "Ajouter 1 XP gagnée", en: 'Add 1 earned XP'},
  xpEarnedMinus: {fr: "Retirer 1 XP gagnée", en: 'Remove 1 earned XP'},
  // Jets
  roll: {fr: 'Lancer un jet', en: 'Roll dice'},
  rollAction: {fr: 'Lancer', en: 'Roll'},
  rouseCheck: {fr: "Test d'exaltation", en: 'Rouse check'},
  remorseCheck: {fr: 'Test de remords', en: 'Remorse check'},
  frenzyCheck: {fr: 'Test de frénésie', en: 'Frenzy check'},
  chooseTrait: {fr: '— choisir —', en: '— choose —'},
  firstTrait: {fr: 'Attribut', en: 'Attribute'},
  secondTrait: {fr: 'Compétence, attribut ou discipline', en: 'Skill, attribute or discipline'},
  none: {fr: 'Aucun', en: 'None'},
  specialty: {fr: 'Spécialité', en: 'Specialty'},
  modifier: {fr: 'Modificateur', en: 'Modifier'},
  impairedPenalty: {fr: 'Diminué', en: 'Impaired'},
  bloodSurge: {fr: 'Coup de sang', en: 'Blood surge'},
  bloodSurgeHint: {fr: "+{{value}} dés, coûte un test d'exaltation", en: '+{{value}} dice, costs a Rouse check'},
  difficulty: {fr: 'Difficulté', en: 'Difficulty'},
  difficultyUnknown: {fr: 'inconnue', en: 'unknown'},
  hiddenRoll: {fr: 'Jet caché (visible par le MJ)', en: 'Hidden roll (DM only)'},
  hiddenRollOther: {fr: 'Jet caché', en: 'Hidden roll'},
  poolSummary: {fr: '{{size}} dés dont {{hunger}} de Soif', en: '{{size}} dice, {{hunger}} Hunger'},
  regularDice: {fr: 'Dés normaux', en: 'Regular dice'},
  regularDiceHint: {fr: 'cliquer pour choisir (3 max)', en: 'click to select (max 3)'},
  hungerDice: {fr: 'Dés de Soif', en: 'Hunger dice'},
  hungerDiceHint: {fr: 'jamais relancés', en: 'never rerolled'},
  successes: {fr: 'succès', en: 'successes'},
  margin: {fr: 'Marge {{value}}', en: 'Margin {{value}}'},
  willpowerReroll: {fr: 'Relancer {{count}}/3 · 1 Volonté', en: 'Reroll {{count}}/3 · 1 Willpower'},
  willpowerRerolled: {fr: 'Volonté dépensée', en: 'Willpower spent'},
  rerolledTag: {fr: 'relancé', en: 'rerolled'},
  reopenRoll: {fr: 'Relancer à la Volonté', en: 'Reroll with Willpower'},
  close: {fr: 'Fermer', en: 'Close'},
  newRoll: {fr: 'Nouveau jet', en: 'New roll'},
  autoFailure: {fr: 'Aucun dé : échec automatique', en: 'No dice: automatic failure'},
  outcome_messyCritical: {fr: 'Critique sanglant', en: 'Messy critical'},
  outcome_criticalWin: {fr: 'Réussite critique', en: 'Critical win'},
  outcome_win: {fr: 'Réussite', en: 'Win'},
  outcome_failure: {fr: 'Échec', en: 'Failure'},
  outcome_totalFailure: {fr: 'Échec total', en: 'Total failure'},
  outcome_bestialFailure: {fr: 'Échec bestial', en: 'Bestial failure'},
  messyIfWin: {fr: 'sanglant si réussite', en: 'messy if it succeeds'},
  bestialIfFail: {fr: 'bestial si échec', en: 'bestial if it fails'},
  rouseSuccess: {fr: 'le sang répond, Soif stable', en: 'the blood answers, Hunger unchanged'},
  rouseFail: {fr: 'Soif +1 ({{value}}/5)', en: 'Hunger +1 ({{value}}/5)'},
  rouseFrenzyRisk: {fr: 'Soif déjà à 5 : risque de frénésie', en: 'Hunger already 5: frenzy risk'},
  remorseSuccess: {fr: 'Humanité préservée, souillures effacées', en: 'Humanity kept, stains cleared'},
  remorseFail: {fr: 'Humanité −1 ({{value}}), souillures effacées', en: 'Humanity −1 ({{value}}), stains cleared'},
  noStains: {fr: 'Aucune souillure : pas de test de remords', en: 'No stains: no remorse check'},
  frenzyResisted: {fr: 'Frénésie résistée', en: 'Frenzy resisted'},
  frenzyLost: {fr: 'La Bête prend le dessus', en: 'The Beast takes over'},
  chat: {fr: 'Chat de campagne', en: 'Campaign chat'},
  tests: {fr: 'Tests', en: 'Checks'},
  tileRouse: {fr: 'Soif', en: 'Rouse'},
  tileRemorse: {fr: 'Remords', en: 'Remorse'},
  tileFrenzy: {fr: 'Frénésie', en: 'Frenzy'},
  stainsCount: {fr: '{{value}} souillure(s)', en: '{{value}} stain(s)'},
  noStainsShort: {fr: 'aucune souillure', en: 'no stains'},
  diceCount: {fr: '{{value}} dés', en: '{{value}} dice'},
  // Pouvoirs, soin, nourriture
  powerRouse: {fr: 'Exaltation {{index}}/{{count}}', en: 'Rouse {{index}}/{{count}}'},
  powerRouseCount: {fr: "{{count}} test(s) d'exaltation", en: '{{count}} Rouse check(s)'},
  activatePower: {fr: 'Activer', en: 'Activate'},
  activatePowerHint: {fr: "Pouvoir sans jet : l'activer fait {{count}} test(s) d'exaltation.", en: 'No roll for this power: activating it makes {{count}} Rouse check(s).'},
  tileMend: {fr: 'Soigner', en: 'Mend'},
  mendCheck: {fr: 'Soin', en: 'Mending'},
  mendHint: {fr: "Test d'exaltation : soigne {{value}} dégât(s) superficiel(s)", en: 'Rouse check: mends {{value}} superficial damage'},
  mendHealed: {fr: '{{value}} dégât(s) superficiel(s) soigné(s)', en: '{{value}} superficial damage mended'},
  superficialCount: {fr: '{{value}} superficiel(s)', en: '{{value}} superficial'},
  noWounds: {fr: 'aucune blessure', en: 'no wounds'},
  tileFeed: {fr: 'Se nourrir', en: 'Feed'},
  hungerShort: {fr: 'Soif {{value}}', en: 'Hunger {{value}}'},
  feedCheck: {fr: 'Se nourrir', en: 'Feeding'},
  feedHunger: {fr: 'Soif {{from}} → {{to}}', en: 'Hunger {{from}} → {{to}}'},
  feedHungerAfter: {fr: 'Soif après le repas (actuelle : {{value}})', en: 'Hunger after feeding (now {{value}})'},
  feedZeroHint: {fr: "Soif 0 : seulement en vidant la victime jusqu'à la mort.", en: 'Hunger 0: only by draining the victim to death.'},
  feedNote: {fr: 'Sur qui, sur quoi ?', en: 'From whom?'},
  feedNotePlaceholder: {fr: 'Un passant, une poche de sang, un rat…', en: 'A passer-by, a blood bag, a rat…'},
  feedAction: {fr: 'Se nourrir', en: 'Feed'},
  noRolls: {fr: 'Aucun jet pour le moment', en: 'No rolls yet'},
  manage: {fr: 'Gérer', en: 'Manage'},
  deleteForever: {fr: 'Supprimer', en: 'Delete'},
  deleteCharacter: {fr: 'Supprimer définitivement', en: 'Delete permanently'},
  deleteCharacterConfirm: {fr: '{{name}} sera effacé pour de bon, sans retour possible. Ses jets passés restent dans le chat. Continuer ?', en: '{{name}} will be erased for good. Past rolls stay in the chat. Continue?'},
  importCharacters: {fr: 'Reprendre des personnages', en: 'Import characters'},
  importHint: {fr: 'Collez le JSON des personnages (un objet ou un tableau). Ils sont créés validés, à votre nom, en attendant de les attribuer.', en: 'Paste the characters JSON (an object or an array). They are created approved, owned by you until assigned.'},
  importAction: {fr: 'Importer', en: 'Import'},
  importDone: {fr: '{{value}} personnage(s) importé(s)', en: '{{value}} character(s) imported'},
  unassigned: {fr: 'À attribuer', en: 'To assign'},
  claimLink: {fr: "Lien d'attribution", en: 'Assignment link'},
  claimLinkCopied: {fr: 'Lien copié', en: 'Link copied'},
  claimTitle: {fr: 'Récupérer un personnage', en: 'Claim a character'},
  claimIntro: {fr: 'Votre MJ vous confie {{name}}. Il apparaîtra dans vos personnages de cette campagne.', en: 'Your GM is handing you {{name}}. It will appear among your characters in this campaign.'},
  claimAction: {fr: 'Récupérer ce personnage', en: 'Claim this character'},
  claimInvalid: {fr: "Ce lien n'est plus valable (déjà utilisé ou remplacé). Demandez-en un nouveau à votre MJ.", en: 'This link is no longer valid (already used or replaced). Ask your GM for a new one.'},
  claimIsDm: {fr: "Vous êtes le MJ : envoyez ce lien au joueur, c'est lui qui doit l'ouvrir.", en: 'You are the GM: send this link to the player, who must open it.'},
  claimError: {fr: "La récupération a échoué. Réessayez ou prévenez votre MJ.", en: 'Claiming failed. Try again or tell your GM.'},
  sceneShow: {fr: 'Montrer une image', en: 'Show an image'},
  sceneHint: {fr: "L'image s'ouvre en plein écran chez les joueurs choisis, avec sa légende, puis reste sur la droite, par-dessus le chat : leur fiche reste visible.", en: "The image opens full screen for the chosen players, with its caption, then stays on the right, over the chat: their sheet stays visible."},
  sceneTitle: {fr: 'Image du MJ', en: "GM's image"},
  sceneNoImage: {fr: 'Aucune image', en: 'No image'},
  sceneChoose: {fr: 'Choisir une image', en: 'Choose an image'},
  sceneChange: {fr: "Changer d'image", en: 'Change image'},
  sceneRecipients: {fr: 'Montrer à', en: 'Show to'},
  sceneEveryone: {fr: 'Toute la coterie', en: 'The whole coterie'},
  sceneSend: {fr: 'Montrer', en: 'Show'},
  sceneStop: {fr: "Retirer l'image", en: 'Remove image'},
  sceneMinimize: {fr: 'Réduire', en: 'Minimize'},
  sceneReopen: {fr: "Revoir l'image du MJ", en: "See the GM's image"},
  sceneZoom: {fr: 'Agrandir', en: 'Enlarge'},
  sceneTooBig: {fr: 'Image trop lourde, même compressée. Essayez une image plus petite.', en: 'Image too large, even compressed. Try a smaller one.'},
  sceneError: {fr: "L'envoi a échoué. Réessayez.", en: 'Upload failed. Try again.'},
  hungerEffects: {fr: 'Effets de Soif', en: 'Hunger effects'},
  switchGame: {fr: 'Changer de jeu', en: 'Switch game'},
  // Accueil d'une campagne
  homeDmDesc: {fr: 'Mener la chronique : validation des fiches, jets, scènes', en: 'Run the chronicle: sheet approval, rolls, scenes'},
  homeNoPlayer: {fr: "Personne n'a encore rejoint la chronique. Partagez le code d'invitation.", en: 'Nobody has joined the chronicle yet. Share the invitation code.'},
  homeYourCharacter: {fr: 'Votre vampire', en: 'Your vampire'},
  homeResumeCreation: {fr: 'Reprendre la création', en: 'Resume creation'},
  homeOtherCharacters: {fr: 'Vos autres personnages', en: 'Your other characters'},
  homeAnotherCharacter: {fr: 'Créer un autre personnage', en: 'Create another character'},
  homeNoCharacterTitle: {fr: 'La nuit vous attend', en: 'The night awaits'},
  homeNoCharacterText: {fr: "Créez votre vampire pour rejoindre la coterie. L'assistant vous guide pas à pas.", en: 'Create your vampire to join the coterie. The wizard guides you step by step.'},
  homeCreateCharacter: {fr: 'Créer mon vampire', en: 'Create my vampire'},
  on: {fr: 'Activés', en: 'On'},
  off: {fr: 'Désactivés', en: 'Off'},
  myCampaigns: {fr: 'Mes campagnes', en: 'My campaigns'},
  campaignCount: {fr: '{{value}} chronique(s) en cours', en: '{{value}} ongoing chronicle(s)'},
  noCampaignYet: {fr: "Aucune campagne pour l'instant. Rejoignez celle de votre MJ avec son code, ou fondez la vôtre.", en: 'No campaign yet. Join your GM\'s with their code, or start your own.'},
  favorite: {fr: 'Favori', en: 'Favorite'},
  newCampaignSection: {fr: 'Rejoindre ou créer une campagne', en: 'Join or create a campaign'},
  joinCampaign: {fr: 'Rejoindre une campagne', en: 'Join a campaign'},
  join: {fr: 'Rejoindre', en: 'Join'},
  createCampaign: {fr: 'Créer une campagne', en: 'Create a campaign'},
  create: {fr: 'Créer', en: 'Create'},
  sceneCaption: {fr: 'Légende (facultatif)', en: 'Caption (optional)'},
  sceneCaptionPlaceholder: {fr: 'Elysium · Opéra Garnier, minuit', en: 'Elysium · Opera house, midnight'},
  sceneIntroSkip: {fr: 'Cliquez pour passer', en: 'Click to skip'},
  rollRequest: {fr: 'Demander un jet', en: 'Request a roll'},
  rollRequestHint: {fr: 'Les joueurs choisis voient la demande au-dessus de leur chat et lancent en un clic, réserve et difficulté pré-remplies.', en: 'The chosen players see the request above their chat and roll in one click, with pool and difficulty filled in.'},
  rollRequestKind: {fr: 'Type de jet', en: 'Roll type'},
  rollRequestPool: {fr: 'Réserve', en: 'Pool'},
  rollRequestSend: {fr: 'Envoyer la demande', en: 'Send request'},
  rollRequestSecondTrait: {fr: 'Compétence ou attribut', en: 'Skill or attribute'},
  rollRequestTargets: {fr: 'Demander à', en: 'Ask'},
  rollRequestFromDm: {fr: 'Le MJ demande un jet', en: 'The GM asks for a roll'},
  rollRequestAnswer: {fr: 'Lancer', en: 'Roll'},
  rollRequestCurrent: {fr: 'Jet demandé', en: 'Requested roll'},
  rollRequestWaiting: {fr: 'en attente', en: 'waiting'},
  rollRequestAllDone: {fr: 'Tout le monde a lancé : la demande se ferme.', en: 'Everyone has rolled: closing the request.'},
  rollRequestClose: {fr: 'Clore la demande', en: 'Close request'},
  rollRequestDifficulty: {fr: 'diff. {{value}}', en: 'diff. {{value}}'},
  rollRequestHidden: {fr: 'caché', en: 'hidden'},
  rollRequestError: {fr: "La demande n'a pas pu être envoyée. Réessayez.", en: 'The request could not be sent. Try again.'},
  dismiss: {fr: 'Masquer', en: 'Dismiss'},
};

export const currentLanguage = () => (i18next.language === 'en' ? 'en' : 'fr');

/** t('generationValue', {value: 12}) → « 12e » */
export const vtmT = (key, params = {}) => {
  const entry = LABELS[key];
  if (!entry) return key;
  const text = entry[currentLanguage()] || entry.fr;
  return Object.entries(params).reduce((acc, [name, value]) => acc.replace(`{{${name}}}`, value), text);
};
